import { UrlPrefixType } from '../interfaces/urlPrefixType.interface';

export const URL_PREFIX_TYPES_TO_DESCRIPTIONS: Record<UrlPrefixType, string> = {
  'deep link':
    'Deep link that gets passed to the application once it is opened. This link can contain any data in query parameters that can be extracted to be used in app.',
  fallback:
    'Fallback URL that users get redirected to, if they try to open the short link from unsupported platform (e.g. desktop PC)',
  'short link':
    'Brand your links completely with a URL prefix made up of a custom Dynamic Links domain (e.g. yourdomain.com) and optional path (ex: yourdomain.com/mypath). Customized domains look more professional and contextual, resulting in more clicks on links.'
};
